import { Pipe, PipeTransform } from '@angular/core';

/** @deprecated - this is moved to libs */
@Pipe({
    name: 'mileageMotorcycle',
})
export class MileageMotorcycle implements PipeTransform {
    transform(input: string | number): string {
        const inputNumber = Number(input);

        if ([3999, 7999, 11999, 15999, 19999, 29999, 30001].includes(inputNumber)) {
            if (inputNumber === 3999) {
                return 'Minder dan 4.000 km';
            }
            if (inputNumber === 7999) {
                return 'Tussen de 4.000 en 8.000 km';
            }
            if (inputNumber === 11999) {
                return 'Tussen de 8.000 en 12.000 km';
            }
            if (inputNumber === 15999) {
                return 'Tussen de 12.000 en 16.000 km';
            }
            if (inputNumber === 19999) {
                return 'Tussen de 16.000 en 20.000 km';
            }
            if (inputNumber === 29999) {
                return 'Tussen de 20.000 en 30.000 km';
            }
            if (inputNumber === 30001) {
                return 'meer dan 30.000 km';
            }
            return;
        }
    }
}
